import React, { useEffect, useState } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { checkJwtExistsAndExpired, logoutSession } from "../services/AuthService";
import { fetchCurrentUser, isAdminRole } from "../services/UserAdminService";

/**
 * Chỉ cho phép role ADMIN (role=1) vào.
 * Nếu không có quyền → logout (xoá session + localStorage) rồi đá về /login.
 */
function AdminRoute() {
    const auth = checkJwtExistsAndExpired();
    const location = useLocation();

    const [state, setState] = useState({
        loading: true,
        allowed: false,
        forceLogout: false,
    });

    useEffect(() => {
        if (!auth) {
            setState({ loading: false, allowed: false, forceLogout: false });
            return;
        }

        let cancelled = false;

        (async () => {
            let role = null;

            try {
                const res = await fetchCurrentUser();
                role = res?.data?.role;
            } catch {
                // Lỗi khi lấy info → coi như không có quyền
            }

            if (cancelled) return;

            if (isAdminRole(role)) {
                setState({ loading: false, allowed: true, forceLogout: false });
                return;
            }

            // Không phải admin → logout toàn bộ (cookie + localStorage)
            try {
                await logoutSession();
            } catch {
                /* ignore BE error, vẫn clear client */
            }
            try {
                localStorage.removeItem("user");
            } catch {
                /* ignore */
            }

            if (!cancelled) {
                setState({ loading: false, allowed: false, forceLogout: true });
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [auth]);

    // Chưa đăng nhập → về login (không force logout vì chưa có session)
    if (!auth) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    if (state.loading) {
        return (
            <div className="h-[100dvh] w-full flex items-center justify-center bg-white">
                <div className="flex items-center gap-3 text-gray-500 text-sm">
                    <div className="w-5 h-5 border-2 border-gray-300 border-t-red-600 rounded-full animate-spin" />
                    Đang kiểm tra quyền truy cập…
                </div>
            </div>
        );
    }

    // Không phải admin → đã logout xong ở trên → điều hướng về login
    if (!state.allowed) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
}

export default AdminRoute;
